module.exports = __webpack_public_path__ + "static/hello-people-b6c6efa8c3957064b02d66254c30f84c.jpg";